import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QuestionResponse } from '../models/QuestionResponse';

@Injectable({
    providedIn: 'root',
})
export class QuestionsService {
    constructor(private http: HttpClient) {}

    getQuestionsForModule(moduleId: string): Observable<QuestionResponse> {
        const url = `/api/v1/questions/modules/${moduleId}/me`;

        return this.http.get<QuestionResponse>(url);
    }

    postQuestionAnswer(
        moduleId: string,
        questionId: number,
        questionUniqueId: string,
        correctAnswer: boolean,
        levelValidated: boolean,
        answers: string[]
    ): Observable<any> {
        const url = `/api/v1/questions/answer/`;
        const body: any = {
            module_id: moduleId,
            question_id: questionId,
            question_unique_id: questionUniqueId,
            correct_answer: correctAnswer,
            level_validated: levelValidated,
            user_answers: answers,
        };

        return this.http.post<any>(url, body);
    }
}
